import styles from '../../index.module.scss';
import type { DirectAllocationChat } from '../useDirectAllocationChat';

export default function PayPeriodCard({ chat }: { chat: DirectAllocationChat }) {
	return (
		<div className={styles['action-card']}>
			<div className={styles['smart-import-card__buttons-wrap']}>
				{chat.payPeriodOptions.map((p) => (
					<button
						key={p.id}
						type="button"
						className={styles['action-card__confirm']}
						onClick={() => chat.selectPayPeriod(p.id)}
					>
						{p.label}
					</button>
				))}
			</div>
		</div>
	);
}
